import React from 'react';
import Box from '@amzn/awsui-components-console/box';
import './PortalHeader.scss';

export interface PortalHeaderProps {
  title: string;
  subtitle: string;
}

const PortalHeader: React.FC<PortalHeaderProps> = ({ title, subtitle }) => {
  return (
    <div className="portal-header">
      <Box textAlign="center">
        <h1 className="portal-header__title">{title}</h1>
        <p className="portal-header__subtitle">{subtitle}</p>
      </Box>
    </div>
  );
};

export default PortalHeader;
